<div id="reasons" class="section-container md:px-20 md:py-20 sl:px-4 sl:py-8">
    <div class="grid grid-cols-1 xl:grid-cols-2 gap-x-24">
        <div class="w-full">
            <div class="title md:text-64 sl:text-36">Reasons</div>
            <div class="sub-title md:text-56 sl:text-32">why you choose us.</div>
        </div>
        <div class="w-full sl:mt-4 xl:mt-0">
            <div class="description  md:text-20 sl:text-14 xl:h-full xl:flex xl:items-center">Our dedicated team excels at turning your ideas into tangible outcomes. Leveraging a rigorously managed scrum framework and a refined agile development lifecycle, we ensure the consistent realization of your objectives.</div>
        </div>
    </div>
    <div class="md:mt-16 sl:mt-8">
        <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 xl:gap-x-24 md:gap-24 sl:gap-y-16">
            <div class="card sl:px-[20px] sl:py-[20px] md:px-[24px] md:pt-[30px] md:pb-[24px] sl:leading-150 md:leading-130" *ngFor="let item of reasons">
                <div class="title flex flex-row md:text-24 sl:text-16 sl:pb-[8px] md:pb-[12px]">
                    <div class="mr-[6px] ">{{ item.reason }}</div>
                    <img src="assets/images/reasons-star.svg" alt="star" class="sl:h-4 sl:w-4 md:h-6 md:w-6">
                </div>
                <div class="description md:text-14 sl:text-12">{{ item.description }}</div>
            </div>
        </div>
    </div>
</div>
